import Vue from 'vue'
import Router from 'vue-router'

// Импортируем в роутер все используемые компоненты
const ErrorPage404 = () => import(/* webpackChunkName: "ErrorPage404" */ "@/views/ErrorPage404.vue")
//const StartPage = () => import(/* webpackChunkName: "StartPage" */ "@/views/StartPage.vue")
const LoginPage = () => import(/* webpackChunkName: "LoginPage" */ "@/views/LoginPage.vue")
const ForgotPage = () => import(/* webpackChunkName: "ForgotPage" */ "@/views/ForgotPage.vue")
const ResetPage = () => import(/* webpackChunkName: "ResetPage" */ "@/views/ResetPage.vue")
const CheckSign = () => import(/* webpackChunkName: "CheckSign" */ "@/views/CheckSign.vue")
const CostCalc = () => import(/* webpackChunkName: "CostCalc" */ "@/views/CostCalc.vue")
const PrivacyPolicy = () => import(/* webpackChunkName: "PrivacyPolicy" */ "@/views/PrivacyPolicy.vue")
const SignUp = () => import(/* webpackChunkName: "SignUp" */ "@/views/SignUp.vue")
const ContactsPage = () => import(/* webpackChunkName: "ContactsPage" */ "@/views/ContactsPage.vue")
const InfoPage = () => import(/* webpackChunkName: "InfoPage" */ "@/views/InfoPage.vue")
const InfoItem = () => import(/* webpackChunkName: "InfoItem" */ "@/views/InfoItem.vue")
const ApplicationView = () => import(/* webpackChunkName: "ApplicationView" */ "@/views/ApplicationView.vue")
const ApplicationCard = () => import(/* webpackChunkName: "ApplicationCard" */ "@/views/ApplicationCard.vue")
const ApplicationCreate = () => import(/* webpackChunkName: "ApplicationCreate" */ "@/views/ApplicationCreate.vue")
const UserProfile = () => import(/* webpackChunkName: "UserProfile" */ "@/views/UserProfile.vue")
const UserDocuments = () => import(/* webpackChunkName: "UserDocuments" */ "@/views/UserDocuments.vue")
const UserNotices = () => import(/* webpackChunkName: "UserNotices" */ "@/views/UserNotices.vue")
const AdminApplications = () => import(/* webpackChunkName: "AdminApplications" */ "@/views/AdminApplications.vue")
const AdminUsers = () => import(/* webpackChunkName: "AdminUsers" */ "@/views/AdminUsers.vue")

const UsersAdd = () => import(/* webpackChunkName: "UsersAdd" */ "@/views/UsersAdd.vue")
const UsersProfile = () => import(/* webpackChunkName: "UsersProfile" */ "@/views/UsersProfile.vue")
const UsersMonitoring = () => import(/* webpackChunkName: "UsersMonitoring" */ "@/views/UsersMonitoring.vue")
const UsersGroups = () => import(/* webpackChunkName: "UsersGroups" */ "@/views/UsersGroups.vue")
const UsersGroupsEdit = () => import(/* webpackChunkName: "UsersGroupsEdit" */ "@/views/UsersGroupsEdit.vue")
const UsersGroupsAdd = () => import(/* webpackChunkName: "UsersGroupsAdd" */ "@/views/UsersGroupsAdd.vue")
const UsersAttendance = () => import(/* webpackChunkName: "UsersAttendance" */ "@/views/UsersAttendance.vue")
const UsersList = () => import(/* webpackChunkName: "UsersList" */ "@/views/UsersList.vue")
const UsersEdit = () => import(/* webpackChunkName: "UsersEdit" */ "@/views/UsersEdit.vue")
const PlanProgram = () => import(/* webpackChunkName: "PlanProgram" */ "@/views/PlanProgram.vue")
const PlanThematic = () => import(/* webpackChunkName: "PlanThematic" */ "@/views/PlanThematic.vue")
const PlanLesson = () => import(/* webpackChunkName: "PlanLesson" */ "@/views/PlanLesson.vue")
const LessonsList = () => import(/* webpackChunkName: "LessonsList" */ "@/views/LessonsList.vue")
const LessonsIssues = () => import(/* webpackChunkName: "LessonsIssues" */ "@/views/LessonsIssues.vue")
const HelpBook = () => import(/* webpackChunkName: "HelpBook" */ "@/views/HelpBook.vue")
const ReferenceMaterials = () => import(/* webpackChunkName: "ReferenceMaterials" */ "@/views/ReferenceMaterials.vue")
const TestsConstructor = () => import(/* webpackChunkName: "TestsConstructor" */ "@/views/TestsConstructor.vue")
const TestsResults = () => import(/* webpackChunkName: "TestsResults" */ "@/views/TestsResults.vue")
const ManualBook = () => import(/* webpackChunkName: "ManualBook" */ "@/views/ManualBook.vue")
const MaterialsDatabase = () => import(/* webpackChunkName: "MaterialsDatabase" */ "@/views/MaterialsDatabase.vue")
const SummariesList = () => import(/* webpackChunkName: "SummariesList" */ "@/views/SummariesList.vue")
const TestsEdit = () => import(/* webpackChunkName: "TestsEdit" */ "@/views/TestsEdit.vue")
const TestsFinal = () => import(/* webpackChunkName: "TestsFinal" */ "@/views/TestsFinal.vue")

Vue.use(Router)

// Настройки путей роутера
let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			// путь (URL)
			path: '/',
			// Имя
			name: 'home',
			// Используемый компонент
			component: ApplicationView,
			meta: {
				// Шаблон вывода
				layout: "inside-layout",
				// Требуется ли авторизация для просмотра страницы
				requiresAuth: true,
				// Заголовок в браузере
				title: "Мои заявки"
			}
		},
		{
			path: '/login',
			name: 'login',
			component: LoginPage,
			meta: {
				layout: "inside-layout",
				title: "Вход"
			}
		},
		{
			path: '/forgot',
			name: 'forgot',
			component: ForgotPage,
			meta: {
				layout: "inside-layout",
				title: "Восстановление пароля"
			}
		},
		{
			path: '/reset/:id',
			name: 'reset',
			component: ResetPage,
			props: true,
			meta: {
				layout: "inside-layout",				
				title: "Придумайте новый пароль"
			}
		},
		{
			path: '/check',
			name: 'check',
			component: CheckSign,
			meta: {
				layout: "inside-layout",
				title: "Проверка товарного знака"
			}
		},
		{
			path: '/calc',
			name: 'calc',
			component: CostCalc,
			meta: {
				layout: "inside-layout",
				title: "Калькулятор стоимости регистрации"
			}
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: PrivacyPolicy,
			meta: {
				layout: "inside-layout",
				title: "Политика обработки персональных данных"
			}
		},
		{
			path: '/signup',
			name: 'signup',
			component: SignUp,
			meta: {
				layout: "inside-layout",
				title: "Калькулятор стоимости регистрации"
			}
		},
		{
			path: '/application/view',
			name: 'application-view',
			component: ApplicationView,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Мои заявки"
			}
		},
		{
			path: '/application/card/:application_id',
			name: 'application-card',
			component: ApplicationCard,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Карточка заявки"
			}
		},
		{
			path: '/application/create',
			name: 'application-create',
			component: ApplicationCreate,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Создание заявки"
			}
		},		
		{
			path: '/user/documents',
			name: 'user-documents',
			component: UserDocuments,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Документы по заказам"
			}
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: ContactsPage,			
			meta: {
				layout: "inside-layout",				
				title: "Контакты"
			}
		},
		{
			path: '/info',
			name: 'info',
			component: InfoPage,			
			meta: {
				layout: "inside-layout",				
				title: "Документация"
			}
		},
		{
			path: '/info/:item_id',
			name: 'info-item',
			component: InfoItem,
			props: true,
			meta: {
				layout: "inside-layout",				
				title: "Документация"
			}
		},
		{
			path: '/user/notices',
			name: 'user-notices',
			component: UserNotices,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Уведомления"
			}
		},
		{
			path: '/admin/applications',
			name: 'admin-applications',
			component: AdminApplications,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Админ - Заявки"
			}
		},
		{
			path: '/admin/users',
			name: 'admin-users',
			component: AdminUsers,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Админ - Пользователи"
			}
		},
		{
			path: '/user/profile',
			name: 'user-profile',
			component: UserProfile,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Мой профиль"
			}
		},
		{
			path: '/user/:id',
			name: 'user-view-profile',
			component: UserProfile,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Профиль пользователя"
			}
		},

		{
			path: '/users/add/:department_id',
			name: 'users-add',
			component: UsersAdd,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Регистрация нового пользователя"
			}
		},
		{
			path: '/users/profile',
			name: 'users-profile',
			component: UsersProfile,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Профиль пользователя"
			}
		},
		{
			path: '/users/groups',
			name: 'users-groups',
			component: UsersGroups,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Группы пользователей"
			}
		},
		{
			path: '/users/groups/add',
			name: 'users-groups-add',
			component: UsersGroupsAdd,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Создание новой группы пользователей"
			}
		},
		{
			path: '/users/groups/:id',
			name: 'users-groups-edit',
			component: UsersGroupsEdit,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Редактирование группы пользователей"
			}
		},
		{
			path: '/users/monitoring',
			name: 'users-monitoring',
			component: UsersMonitoring,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Мониторинг пользователей"
			}
		},
		{
			path: '/users/list',
			name: 'users-list',
			component: UsersList,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Список пользователей"
			}
		},
		{
			path: '/users/list/:id',
			name: 'users-list-by-department',
			component: UsersList,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Список пользователей"
			}
		},
		{
			path: '/users/list/type/:type',
			name: 'users-list-by-type',
			component: UsersList,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Список пользователей"
			}
		},
		{
			path: '/users/edit/:id',
			name: 'users-edit',
			component: UsersEdit,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Редактировать пользователя"
			}
		},
		{
			path: '/plan/program',
			name: 'plan-program',
			component: PlanProgram,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Учебная программа"
			}
		},
		{
			path: '/plan/thematic',
			name: 'plan-thematic',
			component: PlanThematic,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Тематический план"
			}
		},
		{
			path: '/lessons/list/:id',
			name: 'lessons-list',
			component: LessonsList,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Список занятий"
			}
		},
		{
			path: '/lessons/issues/:lesson/:issue',
			name: 'lessons-issues',
			component: LessonsIssues,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Учебные вопросы"
			}
		},
		{
			path: '/lessons/plan/:lesson/:issue',
			name: 'plan-lesson',
			component: PlanLesson,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "План занятия"
			}
		},		
		{
			path: '/helpbook',
			name: 'helpbook',
			component: HelpBook,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Помощь"
			}
		},
		{
			path: '/reference/:typeId',
			name: 'reference',
			component: ReferenceMaterials,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Справочные материалы"
			}
		},
		{
			path: '/tests/constructor',
			name: 'tests-constructor',
			component: TestsConstructor,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Конструктор тестов"
			}
		},
		{
			path: '/tests/constructor/:id',
			name: 'tests-edit',
			component: TestsEdit,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Редактирование теста"
			}
		},
		{
			path: '/tests/results',
			name: 'tests-results',
			component: TestsResults,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Результаты тестов"
			}
		},
		{
			path: '/tests/final',
			name: 'tests-final',
			component: TestsFinal,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Итоговое тестирование"
			}
		},
		{
			path: '/manualbook',
			name: 'manualbook',
			component: ManualBook,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Электронный учебник"
			}
		},
		{
			path: '/users/attendance',
			name: 'users-attendance',
			component: UsersAttendance,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Журнал"
			}
		},
		{
			path: '/summaries',
			name: 'summaries-list',
			component: SummariesList,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Перечень конспектов"
			}
		},
		{
			path: '/materials/:typeId',
			name: 'materials',
			component: MaterialsDatabase,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "База учебных материалов"
			}
		},		
		{
			path: "*",
			component: ErrorPage404,
			meta: {
				layout: "inside-layout",
				title: "404: Страница не найдена"				
			}
		}
	]
})

// Проставляем заголовок в браузере в зависимости от текущего пути
router.beforeEach((to, from, next) => {
	const { title } = to.meta
	const brand = localStorage.getItem('app_title') || ""
	document.title = `${title ? title + " — " : ""}${brand}`
	const tokenStamp = localStorage.getItem('app_token')	
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (tokenStamp) {
			next()
			return
		}
		next('/login')
	} else {
		next()
	}
})

export default router